import { split } from 'lodash'
import React, { useCallback, useEffect } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'

import { drupalApiUtils, senecApiUtils } from './api'
import { Steps } from './components/molecules'
import { Intro, Contract, Customer, Vendor, Generator, Overview } from './components/pages'
import { useAppDispatch } from './store/hooks'
import { setActivePageSlice } from './store/slices/activePageSlice'
import { setBlackPostalCodesSlice } from './store/slices/blackPostalCodesSlice'
import { setGeneralInformation } from './store/slices/contractGeneralInformationSlice'
import {
  setBaseContract,
  setHeatContract,
  setFaf1Contract,
  setFaf2Contract,
  setCtgContract,
  clearBaseContract,
  clearHeatContract,
  clearFaf1Contract,
  clearFaf2Contract,
  clearCtgContract
} from './store/slices/contractSlice'
import { getCload4PackageProposalQuery } from './utils/helpers'

function App () {
  const dispatch = useAppDispatch()

  useEffect(() => {
    getZipcodes()
  })

  const getZipcodes = () => {
    drupalApiUtils.getBlackZipcodes()
      .then(data => {
        dispatch(setBlackPostalCodesSlice(split(data?.zip_codes, '\r\n')))
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(`error: ${error}`)
      })
  }

  const getCloud4PackageProposals = useCallback(
    inputs => {
      const query = getCload4PackageProposalQuery(inputs)
      senecApiUtils.getCload4PackageProposal(query)
        .then(data => {
          dispatch(clearBaseContract())
          dispatch(clearHeatContract())
          dispatch(clearFaf1Contract())
          dispatch(clearFaf2Contract())
          dispatch(clearCtgContract())
          if (data) {
            const parsedData = JSON.parse(data)

            dispatch(setBaseContract(parsedData['base-contract']))

            if (parsedData['ctg-contract'] !== null) {
              dispatch(setCtgContract(parsedData['ctg-contract']))
            }
            if (parsedData['heat-contract'] !== null) {
              dispatch(setHeatContract(parsedData['heat-contract']))
            }
            if (parsedData['f-and-f-contract'] && parsedData['f-and-f-contract'].length > 0) {
              dispatch(setFaf1Contract(parsedData['f-and-f-contract'][0]))
            }
            if (parsedData['f-and-f-contract'] && parsedData['f-and-f-contract'].length > 1) {
              dispatch(setFaf2Contract(parsedData['f-and-f-contract'][1]))
            }
            dispatch(setGeneralInformation(parsedData['general-information']))
          }
        })
    },
    [dispatch]
  )

  const pageUrls = ['/', '/tarifNew', '/packages', '/kundendaten', '/stromlieferant', '/erzeugungsanlage', '/bestelluebersicht', '/vielen-dank']
  const navigate = useNavigate()

  const changeActivePage = useCallback((pageUrl: string) => {
    if (pageUrl === '/vielen-dank') {
      const pageFullUrl = window.location.href
      window.location.href = `${pageFullUrl.slice(0, pageFullUrl.lastIndexOf('/'))}${pageUrl}`
    } else {
      const activePageNumber = pageUrls.indexOf(pageUrl) + 1
      dispatch(setActivePageSlice(activePageNumber))
      navigate(pageUrl)
      window.scrollTo(0, 0)
    }
  },
  []
  )

  return (
    <div className='react-form__wrapper'>
      <Routes>
        {['/angebot', '/kundendaten', '/stromlieferant', '/erzeugungsanlage', '/bestelluebersicht'].map((path, index) => {
          return (
            <Route
              path={path}
              element={
                <Steps/>
              }
              key={index}
            />
          )
        })}
      </Routes>

      <Routes>
        <Route
          path='/'
          element={
            <Intro
              nextPage='/angebot'
              changeActivePage={changeActivePage}
              getProposals={getCloud4PackageProposals}
            />
          }
        />
        <Route
          path='/angebot'
          element={
            <Contract
              nextPage='/kundendaten'
              prevPage='/'
              changeActivePage={changeActivePage}
            />
          }
        />
        <Route
          path='/kundendaten'
          element={
            <Customer
              nextPage='/stromlieferant'
              prevPage='/angebot'
              changeActivePage={changeActivePage}
            />
          }
        />
        <Route
          path='/stromlieferant'
          element={
            <Vendor
              nextPage='/erzeugungsanlage'
              prevPage='/kundendaten'
              changeActivePage={changeActivePage}
            />
          }
        />
        <Route
          path='/erzeugungsanlage'
          element={
            <Generator
              nextPage='/bestelluebersicht'
              prevPage='/stromlieferant'
              changeActivePage={changeActivePage}
            />
          }
        />
        <Route
          path='/bestelluebersicht'
          element={
            <Overview
              nextPage='/vielen-dank'
              prevPage='/erzeugungsanlage'
              changeActivePage={changeActivePage}
            />
          }
        />
        <Route
          path='*'
          element={<p>Not found!!!</p>}
        />
      </Routes>
    </div>
  )
}

export default App
